<template>
  <div class="date-column" @click="openPicker">
    <div class="date-card">
      <div class="date-big">{{ dateLabel }}</div>
      <div class="date-weekday">{{ weekdayLabel }}</div>
    </div>
    <div class="date-current-time">{{ currentTimeLabel }}</div>
    <div class="date-picker-anchor" aria-hidden="true">
      <el-date-picker
        ref="picker"
        v-model="internalDate"
        type="date"
        format="DD.MM.YYYY"
        value-format="YYYY-MM-DD"
        placement="bottom-start"
        @change="onDateChange"
        class="date-picker-overlay"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DateColumn',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalDate: this.modelValue || new Date().toISOString().slice(0, 10),
      nowTs: Date.now(),
      timer: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.nowTs = Date.now()
    }, 30000)
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer)
  },
  watch: {
    modelValue(newVal) {
      if (newVal && newVal !== this.internalDate) {
        this.internalDate = newVal
      }
    }
  },
  computed: {
    weekdayLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (Number.isNaN(d.getTime())) return ''
      const weekdays = ['воскресение', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
      return weekdays[d.getDay()]
    },
    dateLabel() {
      if (!this.internalDate) return ''
      const d = new Date(this.internalDate)
      if (Number.isNaN(d.getTime())) return ''
      const day = String(d.getDate()).padStart(2, '0')
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const year = d.getFullYear()
      return `${day}.${month}.${year}`
    },
    currentTimeLabel() {
      const now = new Date(this.nowTs)
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      return `${hh}:${mm}`
    }
  },
  methods: {
    onDateChange(newDate) {
      if (!newDate) return
      this.internalDate = newDate
      this.$emit('update:modelValue', newDate)
    },
    openPicker() {
      const picker = this.$refs.picker
      if (picker && typeof picker.handleOpen === 'function') {
        picker.handleOpen()
      }
    }
  }
}
</script>

<style scoped>
.date-column {
  height: 84px;
  width: 112px;
  background: transparent;
  text-align: center;
  cursor: pointer;
  user-select: none;
  padding: 0 4px 2px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-family: var(--ui-font-family-base);
}

.date-card {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: var(--cal-surface-header);
  border: 0;
  padding: 7px 4px 5px;
  box-shadow: none;
}

.date-big {
  font-size: 15px;
  line-height: 1.02;
  margin-bottom: 2px;
  color: var(--cal-text-inverse);
  font-weight: 600;
  letter-spacing: 0;
}

.date-weekday {
  font-size: 11px;
  line-height: 1;
  color: var(--cal-text-primary);
  font-weight: 700;
}

.date-current-time {
  width: 100%;
  height: 31px;
  border-radius: 4px;
  border: 0;
  background: var(--cal-surface-header);
  color: var(--cal-text-inverse);
  font-size: 20px;
  line-height: 31px;
  font-weight: 600;
  overflow: hidden;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.date-picker-anchor {
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 2;
  pointer-events: none;
}

.date-picker-overlay {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  opacity: 0 !important;
  overflow: hidden !important;
  pointer-events: none !important;
}

.date-column :deep(.date-picker-overlay .el-input__wrapper),
.date-column :deep(.date-picker-overlay .el-input),
.date-column :deep(.date-picker-overlay .el-input__inner),
.date-column :deep(.date-picker-overlay .el-date-editor) {
  opacity: 0 !important;
  pointer-events: none !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}
</style>

